import { useGetMe } from '@morfi/backend-sdk-v2/client';

/**
 * True when an operator has restricted the signed-in account (Morfi Jail):
 * buying, backing, boosting and creating are blocked, while selling, claiming
 * and withdrawing still work. The relay is the enforcement point; this only
 * disables the matching controls up front.
 */
export function useTradingRestricted(): boolean {
  const me = useGetMe({ fields: ['tradingRestricted'] });
  return me.data?.tradingRestricted === true;
}
